import React, { useMemo } from "react";
import { TablePagingProps } from "src/components/molecules/PagingButtons/PagingButtons";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { Span } from "./styles";
import { getPagingIntervals } from "./utils";

type Props = Omit<TablePagingProps, "onPageChange">;

const PagingInfo = ({ rowsPerPage, totalRowCount, currentPage }: Props) => {
  const formatMsg = useFormatMsg();
  const pagingIntervals = useMemo(
    () => getPagingIntervals(rowsPerPage, totalRowCount),
    [rowsPerPage, totalRowCount]
  );

  const interval = pagingIntervals[currentPage - 1];

  if (!interval || !interval.length) return null;

  const [from, to] = interval;

  return (
    <Span data-cy="row-counting">
      {formatMsg("table.paging.info", {
        from,
        to,
        totalRowCount,
      })}
    </Span>
  );
};

export default PagingInfo;
